/**
 * One build, two front-ends:
 *   /        -> the website (Telegram OAuth or user name / email + password, session saved in the browser)
 *   /mini/*  -> the Telegram Mini App (automatic login with initData -> user created / updated by tgUserId)
 *
 * Opened inside Telegram on any other path (e.g. BotFather "Main Mini App" URL or a t.me/<bot>/app link set to the root)
 * -> move to /mini keeping path, query and #tgWebAppData..., so Telegram users always get the automatic login.
 */
const isMiniPath = (p: string) => p === '/mini' || p.startsWith('/mini/');
const tgInitData = window.Telegram?.WebApp?.initData ?? '';

export const REDIRECTING_TO_MINI = !isMiniPath(window.location.pathname) && tgInitData !== '';
if (REDIRECTING_TO_MINI) {
  const { pathname, search, hash } = window.location;
  window.location.replace(`/mini${pathname === '/' ? '/' : pathname}${search}${hash}`);
}

export const IS_MINI_APP = isMiniPath(window.location.pathname);
export const ROUTER_BASENAME = IS_MINI_APP ? '/mini' : '/';

/** Telegram initData - used only by the Mini App; empty when /mini is opened outside Telegram */
export const TG_INIT_DATA = IS_MINI_APP ? tgInitData : '';
